import React, { useEffect } from "react";
import "../.././Reports.scss";
import {
  BatchSummaryReportDataType,
  TotalBatchSummaryDataType,
} from "../../../../redux/reports/reportsType";
import { currencySignAndNegativeValueAdjust } from "../../../../utils/commonFunctions";


type AppProps = {
  batchSummaryReportData: [] | BatchSummaryReportDataType[];
  totalBatchSummaryData: TotalBatchSummaryDataType;
  currencySign: string | undefined;
};

const BatchSummaryTableData = ({
  batchSummaryReportData,
  totalBatchSummaryData,
  currencySign,
}: AppProps) => {
    const toFixedDecimalNumber = (data: number) => {
        return data === 0
          ? `${currencySign}0`
          : currencySignAndNegativeValueAdjust(
              currencySign,
              data ? data?.toFixed(2)?.toString() : "0"
            );
      };
  const renderTotaldata = () => {
    return (
      <>
        <tr
          className="text-center"
          style={{ backgroundColor: "#d1d0cf", color: "white" }}
        >
          <td className="font-weight-bold text-dark">Total</td>
          <td></td>
          <td></td>
          {/* <td></td> */}
          <td className="font-weight-bold text-dark">
            {currencySign} {""} {totalBatchSummaryData?.total_closing_balance}
          </td>
        </tr>
      </>
    );
  };
  const renderdata = () => {
    const batchSummaryTableData = batchSummaryReportData?.map((e: any) => {
      return (
        <>
          <tr className="text-center" key={e.batch_number}>
            <td className="batch-id">{e?.batch_details?.batch_number}</td>
            <td
              className="text-nowrap batch-summary-col-width"
            >
              {e?.closing_qty} {""} 
              {e?.stock_details?.unit?.slice(
                0,
                e?.stock_details?.unit?.lastIndexOf("(")
              )}
            </td>
            <td
              className="batch-summary-col-width"
            >
             {toFixedDecimalNumber(e?.closing_rate)}
            </td>
            <td
              className="batch-summary-col-width"
            >
              {toFixedDecimalNumber(e?.closing_value)}
            </td>
          </tr>
        </>
      );
    });
    return batchSummaryTableData;
  };
  return (
    <>
      {renderdata()}
      {renderTotaldata()}
    </>
  );
};

export default BatchSummaryTableData;
